// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"Reviews_title-CvbgJ","reviewLink":"Reviews_reviewLink-2lAKr"};